<mat-form-field class="">
  <mat-label>{{ label }}</mat-label>
  <input [type]="inputType" matInput [formControl]="formControl" [autocomplete]="autocomplete" />
  <mat-error class="pb-3" *ngIf="formControl?.hasError('required')"> Pole jest <strong>wymagane</strong> </mat-error>
  <mat-error class="pb-3" *ngIf="formControl?.hasError('nameTaken')"> Taka nazwa już istnieje </mat-error>
  <mat-error class="pb-3" *ngIf="formControl?.hasError('pattern')"> Niewłaściwy format</mat-error>
</mat-form-field>
